import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Input } from '../ui/input';
import { Copy, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const TextRepeaterTool = () => {
  const [text, setText] = useState('');
  const [count, setCount] = useState(3);
  const [separator, setSeparator] = useState('\\n');

  const getSeparator = () => {
    switch (separator) {
      case '\\n': return '\n';
      case '\\t': return '\t';
      case ' ': return ' ';
      case ',': return ', ';
      default: return separator;
    }
  };

  const output = text ? Array(Math.min(count, 1000)).fill(text).join(getSeparator()) : '';

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Repeated text copied!');
  };

  return (
    <div className="space-y-6" data-testid="text-repeater-tool">
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div>
            <label className="text-sm text-muted-foreground mb-2 block">Text to Repeat</label>
            <Textarea
              placeholder="Enter text to repeat..."
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="min-h-[100px] font-mono text-sm bg-muted/50"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Repeat Count</label>
              <Input
                type="number"
                min={1}
                max={1000}
                value={count}
                onChange={(e) => setCount(parseInt(e.target.value) || 1)}
              />
            </div>
            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Separator</label>
              <select
                value={separator}
                onChange={(e) => setSeparator(e.target.value)}
                className="w-full h-10 px-3 rounded-md bg-muted border border-border"
              >
                <option value="\n">New Line</option>
                <option value=" ">Space</option>
                <option value=",">Comma</option>
                <option value="\t">Tab</option>
                <option value="">None</option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            Output ({output.length.toLocaleString()} characters)
          </label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[180px] font-mono text-sm bg-muted/50"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Result
        </Button>
        <Button onClick={() => { setText(''); setCount(3); }} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default TextRepeaterTool;
